import React from "react";
import { isLoginSidePanelLegacy } from "../../utility/constants/authUi";
import { SideArtIcon } from "./icons";
import LoginSideCarousel from "./LoginSideCarousel";

const LoginSidePanelArt = () => {
  if (isLoginSidePanelLegacy()) {
    return (
      <div className="login-side-art">
        <LoginSideCarousel />
      </div>
    );
  }

  return (
    <div className="login-side-art" aria-hidden="true">
      <SideArtIcon />
    </div>
  );
};

export default LoginSidePanelArt;
